import React, { useEffect } from 'react';
import { isIPad13, isTablet } from "react-device-detect";
import { css } from '@emotion/core';
import FlexBox from 'components/atoms/FlexBox';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import BodyText from 'components/atoms/BodyText';
import MultipleCheckboxForm from 'components/molecules/MultipleCheckboxForm';

const styles = {
  checkbox: css({},
  css`
    span{
      color: #333333;
    }
    [class*="-MultipleCheckboxForm"]
      margin-top:0px
    }
  `)
};

const StateStatusFilter: React.FC<{
  stateStatus: Array<number>;
  setStateStatus: (stateStatus: Array<number>) => void;
  id?: string;
  defaultValue?: any
}> = ({ stateStatus, setStateStatus, id= '0', defaultValue }) => {

  useEffect(() => {
    if(stateStatus !== null){
      sessionStorage.setItem(`${id}/sessionData${window.location.pathname}.selectedStateStatusStaffMaster`, stateStatus.toString());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateStatus])

  useEffect(() => {
    let session = sessionStorage.getItem(`${id}/sessionData${window.location.pathname}.selectedStateStatusStaffMaster`);
    if(session !== null) {
      setStateStatus(session.split(',').map((item) => Number(item)));  
    }else {
      setStateStatus(defaultValue || []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return(
    <FlexBox customStyle={css({padding: '8px', paddingLeft: 0})}>
        <FlexBoxItem basis={isIPad13 || isTablet ? '120px' : '100px'}>
          <BodyText> 状態 </BodyText>
        </FlexBoxItem>
        <FlexBoxItem width="580px" customStyle={styles.checkbox}>
          <MultipleCheckboxForm
            name="stateStatus"
            label=""
            items={[
              {
                id: 'onJob',
                label: '在職',
                value: stateStatus?.includes(1)
              },
              {
                id: 'retirement',
                label: '退職',
                value: stateStatus?.includes(2)
              },
              {
                id: 'expectedRetirement',
                label: '退職予定',
                value: stateStatus?.includes(3)
              },
              {
                id: 'beforeJoining',
                label: '入社前',
                value: stateStatus?.includes(4)
              }
            ]}
            setValue={(e) => {
              let stateStatusValue = 0;
              if (e.target.id === 'onJob') {
                stateStatusValue = 1;
              } else if (e.target.id === 'retirement') {
                stateStatusValue = 2;
              } else if (e.target.id === 'expectedRetirement') {
                stateStatusValue = 3;
              } else if (e.target.id === 'beforeJoining') {
                stateStatusValue = 4;
              } 
              if (e.target.value === 'true') {
                setStateStatus(stateStatus.filter((item) => item !== stateStatusValue));
              } else {
                setStateStatus([...stateStatus, stateStatusValue]);
              }
            }}
          />
        </FlexBoxItem>
      </FlexBox>
  );
};

export default StateStatusFilter;
